var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { PageHeader } from './page-header';
import { ContentEntityLayout } from './content-entity-layout';
import { useKnowledgeHubPage } from '../context/knowledge-hub-page-context';
import { ActiveEntityProvider } from '../context/active-entity-context';
import { SliceLayout } from './slice-layout';
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 1em;\n  "], ["\n    font-size: 1em;\n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 1em;\n    margin-bottom: ", ";\n  "], ["\n    font-size: 1em;\n    margin-bottom: ", ";\n  "])), theme.UNIT(8))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled(PageHeader)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Content: styled(ContentEntityLayout)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var PostLayout = function (props) {
  var className = props.className,
    entity = props.entity;
  var pageKnowledgeHub = useKnowledgeHubPage();
  if (!entity) {
    return null;
  }
  return React.createElement(ActiveEntityProvider, {
    value: pageKnowledgeHub
  }, React.createElement(My.Container, {
    className: className
  }, React.createElement(My.Header, {
    entity: entity
  }), React.createElement(SliceLayout, {
    verticalPadding: 'content',
    entity: entity
  }, React.createElement(My.Content, {
    entity: entity
  }))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;